import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="container-iyaf py-32 text-center">
      <p className="eyebrow text-iyaf-blue mb-4">404</p>
      <h1 className="font-display text-6xl sm:text-7xl font-extrabold tracking-tight mb-6">{t("notFound.title")}</h1>
      <p className="font-editorial text-2xl text-iyaf-ink/70 mb-8">{t("notFound.body")}</p>
      <Link to="/" className="inline-flex items-center gap-2 px-7 py-4 rounded-full bg-iyaf-ink text-white font-semibold hover:bg-iyaf-blue transition">
        {t("notFound.cta")}
      </Link>
    </div>
  );
}
